import { Component } from 'react';
import {Col, Container, Row, Tab, Tabs} from 'react-bootstrap';
import {connect} from 'react-redux';
import MessagesList from './messages-list';
import PageTitle from '../common/page-title';
import InlineCKEditor from '../common/editor/inline-editor';
import {getMessages, getSentMessages} from '../../actions/messages';
import {loadPageContent} from '../../actions/content';

import './styles.css';
import {MESSAGE_RECEIVED, MESSAGE_SENT} from '../../data/messageTypes';

class MyMessages extends Component {
  pageSlug = 'my-messages';

  state = {
    showRead: true,
    showUnread: true,
    tab: 'received',
    page: 1,
    sentPage: 1
  };

  UNSAFE_componentWillMount() {
    const {dispatch} = this.props;
    dispatch(getMessages());
    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  // Changing the read/unread filter changes the result set, so start again from page 1.
  onFilterChanged = (filter, value) => {
    this.setState({[filter]: value, page: 1}, () => {
      this.props.dispatch(getMessages(this.readFilter(), 1));
    });
  };

  readFilter = () => {
    const {showRead, showUnread} = this.state;

    if (!showRead) {
      return showUnread ? 0 : undefined;
    }

    return showUnread ? undefined : 1;
  };

  handlePageChange = (page) => {
    this.setState({page}, () => this.props.dispatch(getMessages(this.readFilter(), page)));
  };

  handleSentPageChange = (sentPage) => {
    this.setState({sentPage}, () => this.props.dispatch(getSentMessages(sentPage)));
  };

  // A delete can empty the page we are sitting on (e.g. the only message on the last page),
  // in which case the server reports fewer pages than the one we are asking for — fall back
  // to the new last page instead of rendering an empty grid.
  componentDidUpdate(prevProps) {
    const {paging, sentPaging} = this.props;
    const {page, sentPage} = this.state;

    if (paging !== prevProps.paging && page > paging.number) {
      this.handlePageChange(paging.number);
    }

    if (sentPaging !== prevProps.sentPaging && sentPage > sentPaging.number) {
      this.handleSentPageChange(sentPaging.number);
    }
  }

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  handleTabSelect = (tab) => {
    const {dispatch} = this.props;

    if (tab === MESSAGE_SENT) {
      this.setState({tab, sentPage: 1}, () => dispatch(getSentMessages(1)));
    } else {
      this.setState({tab, page: 1}, () => dispatch(getMessages(this.readFilter(), 1)));
    }
  };

  render() {
    const {
      messages, fetching, fetched, contents, sentFetching, sentFetched, sentMessages, area,
      paging, sentPaging
    } = this.props;

    const {
      showRead, showUnread, tab, page, sentPage
    } = this.state;

    return (
      <Container className="my-messages user-inner-container">
        <Row>
          <Col lg={12}>
            <PageTitle>
              My messages
            </PageTitle>
          </Col>
        </Row>
        <Row>
          <Col className="my-messages-editable-content" lg={12}>
            <InlineCKEditor
              identifier={`${this.pageSlug}_content_text`}
              onContentSaved={this.handleContentSaved}
              contents={contents[`${this.pageSlug}_content_text`]}
            />
          </Col>
        </Row>
        <Row>
          <Col className="my-messages-container" lg={12}>
            <Tabs activeKey={tab} onSelect={this.handleTabSelect} id="myMessagesTab">
              <Tab eventKey={MESSAGE_RECEIVED} title="My messages">
                <MessagesList
                  messages={messages}
                  fetching={fetching}
                  fetched={fetched}
                  showRead={showRead}
                  showUnread={showUnread}
                  onFilterChanged={this.onFilterChanged}
                  messageType={MESSAGE_RECEIVED}
                  area={area}
                  currentPage={page}
                  totalPages={paging.number}
                  onPageChange={this.handlePageChange}
                />
              </Tab>
              <Tab eventKey={MESSAGE_SENT} title="My sent messages">
                <MessagesList
                  messages={sentMessages}
                  fetching={sentFetching}
                  fetched={sentFetched}
                  showRead={showRead}
                  showUnread={showUnread}
                  onFilterChanged={this.onFilterChanged}
                  messageType={MESSAGE_SENT}
                  currentPage={sentPage}
                  totalPages={sentPaging.number}
                  onPageChange={this.handleSentPageChange}
                />
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  messages: state.messages.messages,
  sentMessages: state.messages.sentMessages,
  fetched: state.messages.fetched,
  fetching: state.messages.fetching,
  sentFetching: state.messages.sentFetching,
  sentFetched: state.messages.sentFetched,
  paging: state.messages.paging,
  sentPaging: state.messages.sentPaging,
  contents: state.content.list
});

export default connect(mapStateToProps)(MyMessages);
